import React, {Component} from 'react';
import {Field, FastField, ErrorMessage} from 'formik';
import get from 'lodash/get';
import classNames from 'classnames';
import {constants} from '@neosvoc/nv-platform-core-common';
import {FormattedMessage, injectIntl} from 'react-intl';
import messages from '../../../../../res/translations/messages';
import ChoiceOption from './ChoiceOption';
import Error from '../../../Error';

class MultipleChoiceLogic extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        const {intl, id, field, item, form} = this.props;

        return (
            <div className="row">
                <div className="col">
                    <label className="col-form-label" htmlFor={`${id}.condition.operator`}><FormattedMessage {...messages.filters.operator} /></label>
                    <FastField id={`${id}.condition.operator`} name={`${field.name}.condition.operator`}
                        className={classNames('form-control custom-select',
                            {error: get(form.errors, `${field.name}.condition.operator`) && get(form.touched, `${field.name}.condition.operator`)})}
                        component="select">
                        <option value="">{intl.formatMessage(messages.filters.select)}</option>
                        <option value={constants.EDITOR_OPERATORS.IN}>{intl.formatMessage(messages.filters.operators.contains)}</option>
                        <option value={constants.EDITOR_OPERATORS.NOT_IN}>{intl.formatMessage(messages.filters.operators.notContains)}</option>
                    </FastField>
                    <ErrorMessage name={`${field.name}.condition.operator`}>
                        {(message) => <Error reason={message.key} reasonParams={message.params} />}
                    </ErrorMessage>
                </div>
                <div className="col">
                    <label className="col-form-label" htmlFor={`${id}.condition.value`}><FormattedMessage {...messages.filters.value} /></label>
                    <Field id={`${id}.condition.value`} name={`${field.name}.condition.value`}
                        className={classNames('form-control custom-select',
                            {error: get(form.errors, `${field.name}.condition.value`) && get(form.touched, `${field.name}.condition.value`)})}
                        component="select">
                        <option value="">{intl.formatMessage(messages.filters.select)}</option>
                        {item.choices.map((item) => <ChoiceOption key={item.id} {...item} />)}
                    </Field>
                    <ErrorMessage name={`${field.name}.condition.value`}>
                        {(message) => <Error reason={message.key} reasonParams={message.params} />}
                    </ErrorMessage>
                </div>
            </div>
        );
    }
}

export default injectIntl(MultipleChoiceLogic);
